var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showNav),expression:"!showNav"}],attrs:{"id":"menuContainer"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }